import axios from "axios";

export const getCitiesLocationData = async() => {
    const citiesLocationData = await axios.get(
        `${process.env.REACT_APP_PROJECT_API_URL}/V1/directory/cities`
    );
  
    return citiesLocationData;
};

export const getCountriesLocationData = async() => {
    const countriesLocationData = await axios.get(
        `${process.env.REACT_APP_PROJECT_API_URL}/V1/directory/countries`
    );
 
    return countriesLocationData;
};

export const getStoresLocationData = async() => {
    const storesLocationData = await axios.get(
        `${process.env.REACT_APP_PROJECT_API_URL}/V1/directory/stores`
    );
   
    return storesLocationData;
};

export const getEnableStoresLocationData = async() => {
    const storesLocationData = await axios.get(
        `${process.env.REACT_APP_PROJECT_API_URL}/V1/directory/enabled-stores`
    );
    // console.log("stores")
    // console.log(storesLocationData, "storesLocationData in identifier")
    return storesLocationData;
};